import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'
import { BaseEntity } from '../base/BaseEntity'
import { WebhookEventEnum } from './WebhookEventEnum'

@ObjectType()
@InputType('WebhookConfigInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class WebhookConfig extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('whc') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String, required: true })
  url: string

  @Field(() => [WebhookEventEnum])
  @Prop({ type: [String], enum: WebhookEventEnum })
  subscribedEvents: string[]

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  secret?: string
}
